import axios from "axios";
import { API_URL, getAxiosConfig } from "./common";

export const getBadges = async () => {
  const badges = await axios.get(`${API_URL}/badges`, await getAxiosConfig());
  return badges;
};
